import TPriceHistoryDetail from './index.vue';

TPriceHistoryDetail.install = app => {
  app.component(TPriceHistoryDetail.name, TPriceHistoryDetail);
};

export default TPriceHistoryDetail;
